import { Component, DestroyRef, Input, inject, signal } from '@angular/core';
import { EntryData, ProviderData } from '../structure-data.models';
import { Store } from '@ngrx/store';
import { UtilService } from 'src/app/util.service';
import { EntryService } from '../entry.service';
import { GoogleAnalyticsService } from 'src/app/google-analytics.service';
import { PlatformService } from 'src/app/platform.service';
import { combineLatest, map } from 'rxjs';
import { EntrySelectors } from 'src/app/state/entry.selectors';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FoldseekService } from 'src/app/foldseek-table/foldseek.service';
import { FoldseekapiService } from 'src/app/foldseek-table/foldseekapi.service';

@Component({
  selector: 'similar-structures-tab',
  templateUrl: './similar-structures-tab.component.html',
  styleUrl: './similar-structures-tab.component.css',
  standalone: false
})
export class SimilarStructuresTabComponent {
  @Input() accession: string;
  @Input() afdb_accession: string;
  @Input() uniprotAccession: string;

  public entryData = signal<EntryData>({} as EntryData);
  public providerData = signal<ProviderData>({} as ProviderData);
  private readonly destroyRef = inject(DestroyRef);

  public foldseekService = inject(FoldseekService);

  public foldseekapiService = inject(FoldseekapiService);
  
  constructor(
    private store: Store,
    private gaService: GoogleAnalyticsService,
  ) {}


  
  ngOnChanges(): void {
  }

  async ngOnInit(): Promise<void> {  
    combineLatest([
      this.store.select(EntrySelectors.entryData).pipe(),
      this.store.select(EntrySelectors.providerData).pipe(),
    ])
      .pipe(
        map(([entryData, providerData]) => {
          this.entryData.set(entryData)
          this.providerData.set(providerData)
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
    this.foldseekapiService.accession.set(this.accession);
    this.foldseekapiService.latest_version.set(this.entryData().latestVersion);
    this.foldseekapiService.afdb_accession.set(this.afdb_accession);
  }
  
}
